<template>
<div id="train_list_outer">
  <ul class="list-group" v-if="itemList.length > 0">
    <li class="list-group-item" v-for="(item, index) in itemList">
      <a :href="itemSrc(item)" target="_blank">
        <div>{{item.actionTitle}}</div>
        <div>{{itemDate(item)}}</div>
      </a>
    </li>
  </ul>
  <div v-else style="height: 230px;line-height: 230px;">暂无数据</div>

  <div style="padding-right: 30px;">
    <bottom-paginator
      v-bind:current="pageIndex"
      v-bind:total="totalPage"
      v-bind:paginator-type="1"
      v-on:itemClicked="paginatorClicked"
    />
  </div>
</div>
</template>

<script>
import GlobalInstance from "../../js/shba";
import BottomPaginator from "../BottomPaginator";

export default {
  name: "TrainList",
  props: [
    'listIndex',
    'tag',
  ],
  components: {
    BottomPaginator
  },
  data() {
    return {
      title: '裁判员/教练员列表',
      itemList: [],
      pageIndex: 1,
      size: 10,
      count: 0,
      isLoading: false,
    }
  },
  computed: {
    currentMenuItem() {
      return GlobalInstance.methods.currentMenuItem(this.$route);
    },
    currentTag() {
      return this.tag;
    },
    totalPage() {
      let total = 0;
      if (this.count == 0) {
        total = 0;
      } else {
        total = Math.ceil(this.count / this.size);
      }
      return total;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    paginatorClicked(event) {
      let index = event.index;
      this.pageIndex = index;
      this.loadData();
    },
    loadData() {
      if (this.isLoading) {
        return;
      }
      let pageIndex = this.pageIndex;
      let tag = this.currentTag;
      let params = {
        pageIndex,
        size: this.size,
        type: 1,
        tag
      };
      this.isLoading = true;
      let _this = this;
      this.$store.state.http.ajax.vmActivities(params,function (data) {
        _this.isLoading = false;
        // console.log(data);
        let code = data.code;
        if (code == 0) {
          let newList = data.data;
          _this.count = data.count;

          if (newList.length > 0) {
            _this.itemList = newList;
            return;
          } else {
            _this.itemList = [];
            return;
          }
        }

        _this.$toast('请求失败！');

      },function (data) {
        _this.isLoading = false;
        _this.$toast('请求失败，请重试！');
      });
    },
    itemDate(item) {
      return this.$moment(item.createTime).format('yyyy.MM.DD');
    },
    itemSrc(item) {
      let web = item.newsUrl;
      if (web != null && web.length > 0) {
        return web;
      }
      return '/news/0302/0/' + item.id;
    },
  }
}
</script>

<style scoped>

  #train_list_outer {
    width: 100%;
  }

  #train_list_outer li {
    border: none;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  #train_list_outer ul {
    padding-top: 30px;
    min-height: 400px;
  }

  #train_list_outer a {
    display: flex;
    flex-direction: row;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    color: #666;
    font-size: 1.5rem;
    text-decoration: none;
  }

  #train_list_outer a div:first-child {
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  #train_list_outer a div:last-child {
    text-align: right;
  }

  #train_list_outer a:hover {
    color: #333;
  }

</style>



// WEBPACK FOOTER //
// src/components/train/TrainList.vue